import { useContext } from 'react';

import { SuiThemeContext } from '@hrworks/design-system/components';
import { cx } from '@hrworks/design-system/functions';

import { S } from './Scroller.styles';
import type { ScrollerProps } from './Scroller.types';

export const Scroller = ({ className, ...props }: ScrollerProps) => {
  const { useCustomScrollbars } = useContext(SuiThemeContext);

  return <S.Wrapper className={cx(S.cls.Wrapper, className)} useCustomScrollbars={useCustomScrollbars} {...props} />;
};
